window.anvil.block('text-deco', el => {
	const trigger = el.querySelector('.animate-trigger');
	const animate = el.querySelector('.animate');

	window.gsap.from(animate, {
		y: '100%',
		opacity: 0,
		duration: 0.8,
		ease: 'power3.out',
		scrollTrigger: {
			trigger: trigger,
			start: 'top 80%',
			end: 'bottom 80%',
			toggleActions: 'play none none none',
		}
	});

	const video = el.querySelector('video');
	if (video) {
		function initScrollVideo() {
			window.gsap.to(video, {
				currentTime: video.duration,
				ease: 'none',
				scrollTrigger: {
					trigger: video,
					start: 'top 850px',
					end: '+=750',
					scrub: true,
				}
			});
		}

		if (video.readyState >= 1) {
			initScrollVideo();
		} else {
			video.addEventListener('loadedmetadata', initScrollVideo, { once: true });
		}
	}
});
